import { FormControl, FormLabel } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import { JsonEditor } from "src/scenes/admin/components/JsonEditor";
import { VisibilityJsonSchema } from "src/types/formTemplate/visibility";
import { FormikType } from "./helpers";

type Props = {
  questionId: string;
};
export const QuestionVisibilityJSONEditor: React.FC<Props> = ({
  questionId,
}) => {
  const formik = useFormikContext<FormikType>();
  return (
    <FormControl>
      <FormLabel>Visibility</FormLabel>
      <JsonEditor
        schema={VisibilityJsonSchema}
        height="20rem"
        text={formik.values.questionVisibilityJSON ?? ""}
        onChange={async (text: string) => {
          await formik.setFieldValue("questionVisibilityJSON", text);
        }}
        filename={`visibility_${questionId}.json`}
        hideToolbar
        editorHeight="resizable"
      />
    </FormControl>
  );
};
